
export enum AppRoutes {
    MAIN = 'main',
    BOOK = 'book',
    LOGIN = 'login',
    ADMIN = 'admin'
}

export enum ChildAppRoutes {
    MAIN_PAGE = 'MAIN_PAGE',

}

export const getRouteMainPage = () => '/main'

export const getRouteAdmin = () => '/admin'



